import { useEffect, useState } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import {
  Phone,
  MessageCircle,
  Clock3,
  ShieldCheck,
  Truck,
  Bike,
  Battery,
  Wrench,
  Key,
  Fuel,
  MapPin,
  Star,
  ChevronRight,
  Zap,
  Award,
  Users,
  Headphones,
  CheckCircle2,
  Car,
  ArrowUpRight,
  Menu,
  X,
} from "lucide-react";

const PHONE = "5511988967872";
const PHONE_DISPLAY = "(11) 98896-7872";
const WHATSAPP_URL = `https://wa.me/${PHONE}?text=${encodeURIComponent(
  "Olá Guga Guincho! Preciso de um guincho agora"
)}`;
const TEL_URL = `tel:+${PHONE}`;
const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_guga-guincho-sp/artifacts/xa0ui6zk_ChatGPT_Image_9_de_mai._de_2026__07_56_09-removebg-preview.png";
const HERO_BG =
  "https://customer-assets.emergentagent.com/job_guga-guincho-sp/artifacts/w3vsrnmg_WhatsApp%20Image%202026-05-08%20at%2013.28.11.jpeg";
const METAL_TEXTURE =
  "https://static.prod-images.emergentagent.com/jobs/7e5e7634-dbb9-4d7a-b76d-04d28e911889/images/5b4c8b03722a1af803e3c9df88305c49d52373b4fe6480153559514da59571bb.png";

const GALLERY = [
  {
    url: "https://customer-assets.emergentagent.com/job_guga-guincho-sp/artifacts/62rce327_WhatsApp%20Image%202026-05-08%20at%2013.33.14.jpeg",
    alt: "Guincho Guga transportando carro vermelho à noite em São Paulo",
  },
  {
    url: "https://customer-assets.emergentagent.com/job_7e5e7634-dbb9-4d7a-b76d-04d28e911889/artifacts/efhiyquq_WhatsApp%20Image%202026-05-08+at+13.33.15-3.jpeg",
    alt: "Frota de caminhões guincho Guga em operação noturna",
  },
  {
    url: "https://customer-assets.emergentagent.com/job_7e5e7634-dbb9-4d7a-b76d-04d28e911889/artifacts/4i74bu1c_WhatsApp%20Image%202026-05-08+at+13.33.15.jpeg",
    alt: "Guincho de Porsche preto importado em São Paulo",
  },
  {
    url: "https://customer-assets.emergentagent.com/job_7e5e7634-dbb9-4d7a-b76d-04d28e911889/artifacts/p8ny1j6h_WhatsApp%20Image%202026-05-08+at+13.33.13.jpeg",
    alt: "Guincho noturno transportando Renault prata em São Paulo",
  },
];

const SERVICES = [
  { icon: Clock3, title: "Guincho 24 Horas", desc: "Atendimento ininterrupto, todos os dias do ano, no Campo Limpo e Zona Sul." },
  { icon: Truck, title: "Reboque de Veículos", desc: "Reboque rápido e seguro com plataforma para carros leves e utilitários." },
  { icon: Bike, title: "Guincho para Motos", desc: "Equipamento adequado para motos de qualquer cilindrada com total segurança." },
  { icon: Car, title: "Transporte de Veículos", desc: "Translado entre cidades, residências, oficinas e estacionamentos com agilidade." },
  { icon: Wrench, title: "Troca de Pneu", desc: "Equipe móvel para troca rápida de pneu na rua, avenidas ou rodovias." },
  { icon: Battery, title: "Carga de Bateria", desc: "Auxílio imediato para carros que não dão partida — chegada rápida ao local." },
  { icon: Fuel, title: "Pane Seca", desc: "Combustível de emergência entregue rapidamente em qualquer endereço." },
  { icon: ShieldCheck, title: "Auto Socorro", desc: "Suporte mecânico básico para resolver problemas no local quando possível." },
  { icon: Key, title: "Chaveiro Automotivo", desc: "Abertura de veículos e suporte para chaves travadas ou perdidas." },
  { icon: Truck, title: "Remoção de Veículos", desc: "Remoção de veículos sinistrados, abandonados ou para leilão com documentação." },
  { icon: Zap, title: "Atendimento Emergencial", desc: "Tempo de resposta otimizado em emergências e acidentes em vias urbanas." },
  { icon: Wrench, title: "Transporte para Oficinas", desc: "Levamos seu veículo até a oficina de sua confiança no Campo Limpo e Zona Sul." },
  { icon: Award, title: "Plataforma para Importados", desc: "Caminhão plataforma especial para carros baixos, esportivos e importados." },
  { icon: MapPin, title: "Socorro em Rodovias", desc: "Atendimento em rodovias da Grande SP, Anchieta, Imigrantes, Bandeirantes e mais." },
  { icon: Headphones, title: "Atendimento Residencial", desc: "Guincho residencial e empresarial — buscamos seu veículo onde estiver." },
];

const DIFFERENTIALS = [
  { icon: Clock3, title: "Atendimento 24 horas", desc: "Disponível dia, noite, feriados e finais de semana." },
  { icon: Users, title: "Equipe Especializada", desc: "Profissionais treinados e experientes em todo tipo de veículo." },
  { icon: Zap, title: "Rapidez no Atendimento", desc: "Tempo médio de chegada otimizado no Campo Limpo e em toda Zona Sul." },
  { icon: MapPin, title: "Cobertura Total", desc: "Atendemos toda capital, ABC, Osasco, Guarulhos e Alphaville." },
  { icon: Truck, title: "Equipamentos Modernos", desc: "Plataformas e guinchos de última geração para qualquer porte." },
  { icon: ShieldCheck, title: "Segurança Total", desc: "Transporte com cintas, sapatas e proteção do seu veículo." },
  { icon: Headphones, title: "Suporte Imediato", desc: "Atendimento humano direto pelo WhatsApp e telefone." },
  { icon: Award, title: "Melhor Custo-Benefício", desc: "Preço justo, transparente e sem surpresas no orçamento." },
];

const TESTIMONIALS = [
  { name: "Carlos M.", text: "Chegou muito rápido e resolveu meu problema na hora. Recomendo demais a Guga Guincho." },
  { name: "Fernanda R.", text: "Atendimento excelente e preço justo. Equipe educada e muito profissional." },
  { name: "Rafael S.", text: "Precisava urgente de um guincho na madrugada e me atenderam super rápido. Salvou minha noite." },
];

const ZONES = [
  "Campo Limpo", "Zona Sul", "Capão Redondo", "Vila Andrade", "Morumbi",
];

const NEIGHBORHOODS = [
  "Campo Limpo", "Capão Redondo", "Vila Andrade", "Jardim São Luís", "Pirajussara",
  "Vila Sônia", "Morumbi", "Paraisópolis", "Real Parque", "Santo Amaro", "Brooklin",
  "Granja Julieta", "Vila Olímpia", "Itaim Bibi", "Moema", "Vila Mariana",
  "Jabaquara", "Ipiranga", "Saúde", "Cursino", "Bosque da Saúde", "Mirandópolis",
  "Vila Sofia", "Jardim Marajoara", "Interlagos", "Cidade Dutra", "Socorro",
];

/* ---------- Components ---------- */

const TopBanner = () => (
  <div className="relative overflow-hidden bg-[#fddc04] text-black border-b-2 border-black">
    <div className="flex whitespace-nowrap animate-marquee py-2 font-display font-bold uppercase text-sm tracking-wider">
      {Array.from({ length: 2 }).map((_, dup) => (
        <div key={dup} className="flex shrink-0">
          {[
            { t: "Atendimento 24 horas", color: "text-black" },
            { t: "Guincho em Campo Limpo • Zona Sul", color: "text-[#fc3202]" },
            { t: "Resposta rápida", color: "text-black" },
            { t: "Plataforma para importados", color: "text-[#fc3202]" },
            { t: "Auto socorro emergencial", color: "text-black" },
            { t: "Especialistas na Zona Sul de SP", color: "text-[#fc3202]" },
            { t: "Carros • Motos • Utilitários", color: "text-black" },
          ].map((item, i) => (
            <span key={`${dup}-${i}`} className={`flex items-center gap-3 px-6 ${item.color}`}>
              <Zap className="w-4 h-4" />
              {item.t}
            </span>
          ))}
        </div>
      ))}
    </div>
  </div>
);

const Header = () => {
  const [open, setOpen] = useState(false);
  const links = [
    { href: "#servicos", label: "Serviços" },
    { href: "#diferenciais", label: "Diferenciais" },
    { href: "#trabalhos", label: "Trabalhos" },
    { href: "#areas", label: "Áreas" },
    { href: "#depoimentos", label: "Depoimentos" },
  ];
  return (
    <header
      className="sticky top-0 z-40 bg-black/80 backdrop-blur-md border-b border-zinc-900"
      data-testid="site-header"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex items-center justify-between h-20">
        <a href="#" className="flex items-center gap-3" data-testid="header-logo-link">
          <img src={LOGO_URL} alt="Logo Guga Guincho" className="h-12 w-12 object-contain" />
          <div className="leading-none">
            <div className="font-display font-black text-xl text-[#fddc04] tracking-tight">GUGA GUINCHO</div>
            <div className="text-[10px] uppercase tracking-[0.25em] text-zinc-400">Campo Limpo • Zona Sul • 24h</div>
          </div>
        </a>

        <nav className="hidden lg:flex items-center gap-8">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              className="font-display uppercase text-sm font-bold tracking-widest text-zinc-300 hover:text-[#fddc04] transition-colors duration-150"
              data-testid={`nav-link-${l.label.toLowerCase()}`}
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <a
            href={TEL_URL}
            className="hidden sm:inline-flex items-center gap-2 font-display uppercase font-bold text-sm tracking-wider text-white hover:text-[#fddc04]"
            data-testid="header-phone-link"
          >
            <Phone className="w-4 h-4" /> {PHONE_DISPLAY}
          </a>
          <a
            href={WHATSAPP_URL}
            target="_blank"
            rel="noreferrer"
            className="hidden md:inline-flex items-center gap-2 bg-[#fddc04] hover:bg-[#fc3202] hover:text-white text-black font-display font-bold uppercase tracking-wider text-sm px-5 py-3 transition-colors duration-150"
            data-testid="header-whatsapp-cta"
          >
            <MessageCircle className="w-4 h-4" /> Chamar Agora
          </a>
          <button
            className="lg:hidden p-2 text-white"
            onClick={() => setOpen(!open)}
            aria-label="Abrir menu"
            data-testid="mobile-menu-toggle"
          >
            {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>
      </div>

      {open && (
        <div className="lg:hidden bg-black border-t border-zinc-900" data-testid="mobile-menu">
          <div className="px-4 py-4 flex flex-col gap-4">
            {links.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={() => setOpen(false)}
                className="font-display uppercase text-sm font-bold tracking-widest text-zinc-300 hover:text-[#fddc04]"
                data-testid={`mobile-nav-link-${l.label.toLowerCase()}`}
              >
                {l.label}
              </a>
            ))}
            <a
              href={TEL_URL}
              className="inline-flex items-center gap-2 font-display uppercase font-bold text-sm text-white"
              data-testid="mobile-phone-link"
            >
              <Phone className="w-4 h-4" /> {PHONE_DISPLAY}
            </a>
          </div>
        </div>
      )}
    </header>
  );
};

const Hero = () => (
  <section
    className="relative overflow-hidden grain"
    data-testid="hero-section"
  >
    {/* Background image */}
    <div className="absolute inset-0">
      <img
        src={HERO_BG}
        alt="Caminhão guincho Guga Guincho atendendo emergência em São Paulo"
        className="w-full h-full object-cover animate-hero-zoom"
      />
      <div className="absolute inset-0 bg-gradient-to-r from-black/85 via-black/55 to-black/20" />
      <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent" />
      <div className="absolute inset-0 bg-[#fc3202]/5 mix-blend-multiply" />
    </div>

    <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-20 pb-28 lg:pt-32 lg:pb-40">
      <div className="max-w-3xl">
        <div className="inline-flex items-center gap-2 px-3 py-1 border border-[#fddc04]/40 bg-[#fddc04]/10 mb-6 animate-fade-up">
          <span className="relative flex h-2 w-2">
            <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-[#fddc04] opacity-75"></span>
            <span className="relative inline-flex rounded-full h-2 w-2 bg-[#fddc04]"></span>
          </span>
          <span className="font-display uppercase text-xs tracking-[0.3em] text-[#fddc04]">
            Online agora • Atendendo SP
          </span>
        </div>

        <h1
          className="font-display font-black uppercase text-5xl sm:text-6xl lg:text-7xl xl:text-8xl leading-[0.9] tracking-tight text-white animate-fade-up"
          style={{ animationDelay: "0.1s" }}
          data-testid="hero-title"
        >
          Guincho{" "}
          <span className="text-[#fddc04]">24 Horas</span>
          <br />
          em <span className="relative inline-block">
            <span className="relative z-10">Campo Limpo</span>
            <span className="absolute left-0 bottom-1 h-3 w-full bg-[#fc3202] -z-0"></span>
          </span>
          <span className="block text-2xl sm:text-3xl lg:text-4xl text-zinc-300 mt-3 normal-case tracking-normal font-bold">
            e toda a Zona Sul de São Paulo
          </span>
        </h1>

        <p
          className="mt-6 text-lg sm:text-xl text-zinc-300 max-w-2xl animate-fade-up"
          style={{ animationDelay: "0.2s" }}
          data-testid="hero-subtitle"
        >
          Atendimento <strong className="text-white">rápido, seguro e imediato</strong> em
          Campo Limpo, Zona Sul e região.
        </p>

        <div
          className="mt-10 flex flex-col sm:flex-row gap-4 animate-fade-up"
          style={{ animationDelay: "0.3s" }}
        >
          <a
            href={WHATSAPP_URL}
            target="_blank"
            rel="noreferrer"
            className="inline-flex items-center justify-center gap-3 bg-[#fddc04] hover:bg-[#fc3202] hover:text-white text-black font-display font-black uppercase tracking-wider text-lg px-8 py-5 transition-colors duration-150 animate-pulse-yellow"
            data-testid="hero-whatsapp-button"
          >
            <MessageCircle className="w-6 h-6" />
            Chamar no WhatsApp
            <ArrowUpRight className="w-5 h-5" />
          </a>
          <a
            href={TEL_URL}
            className="inline-flex items-center justify-center gap-3 bg-transparent border-2 border-white hover:border-[#fddc04] hover:text-[#fddc04] text-white font-display font-bold uppercase tracking-wider text-lg px-8 py-5 transition-colors duration-150"
            data-testid="hero-call-button"
          >
            <Phone className="w-6 h-6" />
            Ligar Agora
          </a>
        </div>

        {/* Trust badges */}
        <div
          className="mt-12 grid grid-cols-2 sm:grid-cols-4 gap-4 max-w-2xl animate-fade-up"
          style={{ animationDelay: "0.4s" }}
          data-testid="hero-trust-badges"
        >
          {[
            { icon: Clock3, label: "Atendimento 24h" },
            { icon: Zap, label: "Chegada Rápida" },
            { icon: Award, label: "Preço Justo" },
            { icon: ShieldCheck, label: "Equipe Especializada" },
          ].map((b) => (
            <div
              key={b.label}
              className="flex items-center gap-2 border border-zinc-800 bg-black/60 px-3 py-3"
            >
              <b.icon className="w-5 h-5 text-[#fddc04] shrink-0" />
              <span className="text-xs sm:text-sm font-display uppercase tracking-wide font-bold text-zinc-200">
                {b.label}
              </span>
            </div>
          ))}
        </div>
      </div>
    </div>

    {/* Bottom warning stripes */}
    <div className="bg-stripes-mixed h-3 w-full" />
  </section>
);

const About = () => (
  <section className="relative py-20 lg:py-28 bg-black" id="sobre" data-testid="about-section">
    <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="font-display uppercase tracking-[0.3em] text-xs text-[#fddc04] mb-4">
        / Sobre nós
      </div>
      <h2 className="font-display font-black uppercase text-4xl sm:text-5xl lg:text-6xl leading-none tracking-tight text-white">
        Guga <span className="text-[#fddc04]">Guincho</span>
      </h2>
      <div className="mt-8 grid md:grid-cols-2 gap-8 text-zinc-300 text-base sm:text-lg leading-relaxed">
        <div className="space-y-5">
          <p>
            A <strong className="text-white">Guga Guincho</strong> é referência em{" "}
            <strong className="text-[#fddc04]">guincho e auto socorro 24 horas no Campo Limpo
            e em toda a Zona Sul de São Paulo</strong>, atendendo veículos leves, motos e
            utilitários com a maior agilidade da região.
          </p>
          <p>
            Nossa equipe é preparada para emergências com{" "}
            <strong className="text-white">rapidez, segurança e profissionalismo</strong>,
            garantindo tranquilidade em qualquer situação — de dia, de madrugada, feriado
            ou final de semana.
          </p>
        </div>
        <div className="space-y-5">
          <p>
            Atendemos residências, avenidas, rodovias, estacionamentos e empresas em{" "}
            <strong className="text-[#fddc04]">Campo Limpo, Capão Redondo, Vila Andrade,
            Morumbi, Santo Amaro, Jabaquara, Vila Mariana, Moema, Brooklin</strong> e demais
            bairros da Zona Sul.
          </p>
          <p>
            Trabalhamos com <strong className="text-[#fc3202]">frota própria</strong> e equipamentos
            modernos para transporte seguro de qualquer tipo de veículo, inclusive carros
            importados e baixos.
          </p>
        </div>
      </div>

      <div className="mt-12 grid grid-cols-3 gap-6 max-w-2xl">
        {[
          { num: "24/7", label: "Atendimento", color: "border-[#fddc04]" },
          { num: "+10mil", label: "Resgates", color: "border-[#fc3202]" },
          { num: "100%", label: "Seguro", color: "border-[#fddc04]" },
        ].map((s) => (
          <div key={s.label} className={`border-l-2 ${s.color} pl-4`}>
            <div className="font-display font-black text-3xl sm:text-4xl text-white">{s.num}</div>
            <div className="text-xs uppercase tracking-widest text-zinc-400 mt-1">{s.label}</div>
          </div>
        ))}
      </div>
    </div>
  </section>
);

const Services = () => (
  <section
    id="servicos"
    className="relative py-20 lg:py-28 bg-[#0a0a0a] border-y border-zinc-900"
    data-testid="services-section"
  >
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="max-w-3xl mb-14">
        <div className="font-display uppercase tracking-[0.3em] text-xs text-[#fc3202] mb-4">
          / Serviços
        </div>
        <h2 className="font-display font-black uppercase text-4xl sm:text-5xl lg:text-6xl leading-none tracking-tight text-white">
          O que a Guga <span className="text-[#fc3202]">resolve pra você</span>
        </h2>
        <p className="mt-5 text-zinc-400 text-lg">
          Cobertura completa em guincho, auto socorro e assistência veicular para qualquer
          tipo de emergência no Campo Limpo e Zona Sul de São Paulo.
        </p>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-px bg-zinc-900">
        {SERVICES.map((s, i) => {
          const Icon = s.icon;
          const isOrange = i % 3 === 1;
          const iconBg = isOrange
            ? "bg-[#fc3202] text-white group-hover:bg-[#fddc04] group-hover:text-black"
            : "bg-[#fddc04] text-black group-hover:bg-[#fc3202] group-hover:text-white";
          const numHover = isOrange
            ? "group-hover:text-[#fc3202]/40"
            : "group-hover:text-[#fddc04]/40";
          const arrowColor = isOrange ? "text-[#fc3202]" : "text-[#fddc04]";
          return (
            <div
              key={s.title}
              className="group relative bg-[#0a0a0a] hover:bg-black p-6 transition-colors duration-200"
              data-testid={`service-card-${i}`}
            >
              <div className={`absolute top-3 right-3 font-display text-xs text-zinc-700 ${numHover} transition-colors`}>
                {String(i + 1).padStart(2, "0")}
              </div>
              <div className={`w-12 h-12 flex items-center justify-center mb-5 transition-colors duration-200 ${iconBg}`}>
                <Icon className="w-6 h-6" strokeWidth={2.2} />
              </div>
              <h3 className="font-display font-bold uppercase text-lg text-white tracking-tight leading-tight mb-2">
                {s.title}
              </h3>
              <p className="text-sm text-zinc-400 leading-relaxed">{s.desc}</p>
              <div className={`mt-4 inline-flex items-center gap-1 text-xs uppercase tracking-widest font-display font-bold ${arrowColor} opacity-0 group-hover:opacity-100 transition-opacity`}>
                Solicitar <ChevronRight className="w-3 h-3" />
              </div>
            </div>
          );
        })}
      </div>

      <div className="mt-12 flex flex-col sm:flex-row items-center justify-between gap-6 border-2 border-[#fddc04] p-6 sm:p-8 bg-black">
        <div className="font-display uppercase font-bold text-xl sm:text-2xl text-white">
          Não sabe qual serviço precisa?{" "}
          <span className="text-[#fddc04]">A gente avalia na hora.</span>
        </div>
        <a
          href={WHATSAPP_URL}
          target="_blank"
          rel="noreferrer"
          className="inline-flex items-center gap-2 bg-[#fddc04] hover:bg-[#fc3202] hover:text-white text-black font-display font-bold uppercase tracking-wider text-base px-6 py-4 transition-colors duration-150 shrink-0"
          data-testid="services-whatsapp-cta"
        >
          <MessageCircle className="w-5 h-5" /> Falar no WhatsApp
        </a>
      </div>
    </div>
  </section>
);

const Differentials = () => (
  <section
    id="diferenciais"
    className="relative py-20 lg:py-28 bg-black overflow-hidden"
    data-testid="differentials-section"
  >
    <div
      className="absolute inset-0 opacity-20 pointer-events-none"
      style={{
        backgroundImage: `url(${METAL_TEXTURE})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    />
    <div className="absolute inset-0 bg-gradient-to-b from-black via-black/70 to-black pointer-events-none" />

    <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="max-w-3xl mb-14">
        <div className="font-display uppercase tracking-[0.3em] text-xs text-[#fddc04] mb-4">
          / Diferenciais
        </div>
        <h2 className="font-display font-black uppercase text-4xl sm:text-5xl lg:text-6xl leading-none tracking-tight text-white">
          Por que escolher a <span className="text-[#fddc04]">Guga Guincho?</span>
        </h2>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
        {DIFFERENTIALS.map((d, i) => {
          const Icon = d.icon;
          const isOrange = i % 2 === 1;
          const iconColor = isOrange ? "text-[#fc3202]" : "text-[#fddc04]";
          const hoverBorder = isOrange ? "hover:border-[#fc3202]" : "hover:border-[#fddc04]";
          const barColor = isOrange ? "bg-[#fc3202]" : "bg-[#fddc04]";
          return (
            <div
              key={d.title}
              className={`group relative border border-zinc-800 bg-black/80 p-6 transition-colors duration-150 ${hoverBorder}`}
              data-testid={`differential-card-${i}`}
            >
              <Icon className={`w-8 h-8 mb-4 ${iconColor}`} strokeWidth={2} />
              <h3 className="font-display font-bold uppercase text-lg text-white tracking-tight mb-2">
                {d.title}
              </h3>
              <p className="text-sm text-zinc-400 leading-relaxed">{d.desc}</p>
              <div className={`absolute -bottom-px left-0 h-[2px] w-0 group-hover:w-full transition-all duration-300 ${barColor}`} />
            </div>
          );
        })}
      </div>
    </div>
  </section>
);

const Gallery = () => (
  <section
    id="trabalhos"
    className="relative py-20 lg:py-28 bg-[#0a0a0a]"
    data-testid="gallery-section"
  >
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="max-w-3xl mb-14">
        <div className="font-display uppercase tracking-[0.3em] text-xs text-[#fc3202] mb-4">
          / Galeria
        </div>
        <h2 className="font-display font-black uppercase text-4xl sm:text-5xl lg:text-6xl leading-none tracking-tight text-white">
          Trabalhos <span className="text-[#fc3202]">Realizados</span>
        </h2>
        <p className="mt-5 text-zinc-400 text-lg">
          Confira alguns atendimentos realizados pela Guga Guincho no Campo Limpo e Zona Sul de São Paulo.
        </p>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
        {GALLERY.map((g, i) => {
          const isOrange = i % 2 === 1;
          const badgeBg = isOrange ? "bg-[#fc3202] text-white" : "bg-[#fddc04] text-black";
          const hoverBorder = isOrange ? "hover:border-[#fc3202]" : "hover:border-[#fddc04]";
          return (
            <div
              key={g.url}
              className={`group relative aspect-[4/5] overflow-hidden border border-zinc-900 transition-colors duration-150 ${hoverBorder}`}
              data-testid={`gallery-item-${i}`}
            >
              <img
                src={g.url}
                alt={g.alt}
                loading="lazy"
                className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
              />
              <div className={`absolute top-4 left-4 px-3 py-1 font-display uppercase font-bold text-xs tracking-widest ${badgeBg}`}>
                {String(i + 1).padStart(2, "0")}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  </section>
);

const Areas = () => (
  <section
    id="areas"
    className="relative py-20 lg:py-28 bg-black"
    data-testid="areas-section"
  >
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="grid lg:grid-cols-12 gap-12">
        <div className="lg:col-span-5">
          <div className="font-display uppercase tracking-[0.3em] text-xs text-[#fddc04] mb-4">
            / Áreas atendidas
          </div>
          <h2 className="font-display font-black uppercase text-4xl sm:text-5xl lg:text-6xl leading-none tracking-tight text-white">
            Especialistas em <span className="text-[#fddc04]">Campo Limpo</span> e <span className="text-[#fc3202]">Zona Sul</span>
          </h2>
          <p className="mt-5 text-zinc-400 text-lg leading-relaxed">
            Base de operações estrategicamente localizada para chegar rápido em qualquer
            ponto do Campo Limpo, Capão Redondo, Vila Andrade, Morumbi, Santo Amaro e
            toda a Zona Sul de São Paulo.
          </p>
          <a
            href={WHATSAPP_URL}
            target="_blank"
            rel="noreferrer"
            className="mt-8 inline-flex items-center gap-2 bg-[#fddc04] hover:bg-[#fc3202] hover:text-white text-black font-display font-bold uppercase tracking-wider text-sm px-6 py-4 transition-colors duration-150"
            data-testid="areas-whatsapp-cta"
          >
            <MessageCircle className="w-5 h-5" /> Verificar minha região
          </a>
        </div>

        <div className="lg:col-span-7 space-y-8">
          <div>
            <div className="font-display uppercase font-bold text-sm tracking-widest text-[#fddc04] mb-4">
              Regiões principais
            </div>
            <div className="flex flex-wrap gap-2">
              {ZONES.map((z) => (
                <span
                  key={z}
                  className="border border-zinc-800 bg-zinc-900/40 text-zinc-200 px-4 py-2 font-display uppercase text-sm font-bold tracking-wide hover:border-[#fddc04] hover:text-[#fddc04] transition-colors cursor-default"
                  data-testid={`zone-tag-${z.replace(/\s+/g, "-").toLowerCase()}`}
                >
                  {z}
                </span>
              ))}
            </div>
          </div>
          <div>
            <div className="font-display uppercase font-bold text-sm tracking-widest text-[#fddc04] mb-4">
              Bairros atendidos da Zona Sul
            </div>
            <div className="flex flex-wrap gap-2">
              {NEIGHBORHOODS.map((n) => (
                <span
                  key={n}
                  className="border border-zinc-900 bg-black text-zinc-300 px-3 py-2 text-sm font-medium hover:border-[#fddc04] hover:text-white transition-colors cursor-default"
                  data-testid={`neighborhood-tag-${n.replace(/\s+/g, "-").toLowerCase()}`}
                >
                  {n}
                </span>
              ))}
            </div>
          </div>

          <p className="text-sm text-zinc-500 leading-relaxed">
            Atuamos com guincho 24 horas, reboque rápido e auto socorro emergencial em todo
            o Campo Limpo e Zona Sul de São Paulo, com cobertura completa em Capão Redondo,
            Vila Andrade, Jardim São Luís, Pirajussara, Vila Sônia, Morumbi, Paraisópolis,
            Santo Amaro, Brooklin, Granja Julieta, Vila Olímpia, Itaim Bibi, Moema, Vila
            Mariana, Jabaquara, Ipiranga, Saúde, Cursino, Bosque da Saúde, Mirandópolis,
            Interlagos, Cidade Dutra e Socorro.
          </p>
        </div>
      </div>
    </div>
  </section>
);

const Testimonials = () => (
  <section
    id="depoimentos"
    className="relative py-20 lg:py-28 bg-[#0a0a0a] border-y border-zinc-900"
    data-testid="testimonials-section"
  >
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="max-w-3xl mb-14">
        <div className="font-display uppercase tracking-[0.3em] text-xs text-[#fc3202] mb-4">
          / Depoimentos
        </div>
        <h2 className="font-display font-black uppercase text-4xl sm:text-5xl lg:text-6xl leading-none tracking-tight text-white">
          Quem já chamou, <span className="text-[#fddc04]">recomenda</span>
        </h2>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        {TESTIMONIALS.map((t, i) => (
          <div
            key={t.name}
            className="relative border border-zinc-900 bg-black p-8 hover:border-[#fddc04] transition-colors duration-150"
            data-testid={`testimonial-${i}`}
          >
            <div className="flex items-center gap-1 text-[#fddc04] mb-5">
              {Array.from({ length: 5 }).map((_, k) => (
                <Star key={k} className="w-5 h-5 fill-[#fddc04]" />
              ))}
            </div>
            <p className="text-zinc-200 text-lg leading-relaxed mb-6">"{t.text}"</p>
            <div className="flex items-center gap-3 pt-5 border-t border-zinc-900">
              <div className="w-10 h-10 bg-[#fddc04] text-black font-display font-black flex items-center justify-center">
                {t.name.charAt(0)}
              </div>
              <div>
                <div className="font-display uppercase font-bold text-white tracking-tight">
                  {t.name}
                </div>
                <div className="text-xs uppercase tracking-widest text-zinc-500">
                  Cliente Guga Guincho
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  </section>
);

const FinalCta = () => (
  <section
    id="cta"
    className="relative py-20 lg:py-32 overflow-hidden"
    data-testid="final-cta-section"
  >
    <div className="absolute inset-0">
      <img src={HERO_BG} alt="" className="w-full h-full object-cover" />
      <div className="absolute inset-0 bg-black/85" />
    </div>

    <div className="relative max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
      <div className="inline-flex items-center gap-2 px-3 py-1 border border-[#fc3202]/50 bg-[#fc3202]/10 mb-8">
        <span className="relative flex h-2 w-2">
          <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-[#fc3202] opacity-75"></span>
          <span className="relative inline-flex rounded-full h-2 w-2 bg-[#fc3202]"></span>
        </span>
        <span className="font-display uppercase text-xs tracking-[0.3em] text-[#fc3202]">
          Emergência? Chama agora
        </span>
      </div>

      <h2 className="font-display font-black uppercase text-5xl sm:text-6xl lg:text-7xl xl:text-8xl leading-[0.9] tracking-tight text-white">
        Precisando de <br />
        <span className="text-[#fddc04]">guincho agora?</span>
      </h2>
      <p className="mt-6 text-lg sm:text-xl text-zinc-300 max-w-2xl mx-auto">
        Fale agora com a Guga Guincho e receba atendimento rápido no Campo Limpo, Zona Sul
        e região. Estamos online <strong className="text-white">24 horas por dia</strong>.
      </p>

      <div className="mt-10 flex flex-col sm:flex-row gap-4 justify-center">
        <a
          href={WHATSAPP_URL}
          target="_blank"
          rel="noreferrer"
          className="inline-flex items-center justify-center gap-3 bg-[#fddc04] hover:bg-[#fc3202] hover:text-white text-black font-display font-black uppercase tracking-wider text-lg sm:text-xl px-10 py-6 transition-colors duration-150 animate-pulse-yellow"
          data-testid="final-whatsapp-button"
        >
          <MessageCircle className="w-7 h-7" />
          WhatsApp
        </a>
        <a
          href={TEL_URL}
          className="inline-flex items-center justify-center gap-3 bg-transparent border-2 border-white hover:border-[#fddc04] hover:text-[#fddc04] text-white font-display font-bold uppercase tracking-wider text-lg sm:text-xl px-10 py-6 transition-colors duration-150"
          data-testid="final-call-button"
        >
          <Phone className="w-7 h-7" />
          Ligação
        </a>
      </div>

      <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 gap-4 max-w-xl mx-auto">
        <div className="border border-[#fddc04]/40 bg-black/60 p-4">
          <div className="text-xs uppercase tracking-[0.3em] text-[#fddc04] mb-1">WhatsApp</div>
          <div className="font-display font-bold text-2xl text-white">{PHONE_DISPLAY}</div>
        </div>
        <div className="border border-[#fc3202]/40 bg-black/60 p-4">
          <div className="text-xs uppercase tracking-[0.3em] text-[#fc3202] mb-1">Ligação</div>
          <div className="font-display font-bold text-2xl text-white">{PHONE_DISPLAY}</div>
        </div>
      </div>
    </div>
  </section>
);

const Footer = () => (
  <footer className="relative bg-black border-t border-zinc-900 pt-16 pb-8" data-testid="site-footer">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="grid grid-cols-1 md:grid-cols-4 gap-10 mb-12">
        <div className="md:col-span-2">
          <div className="flex items-center gap-3 mb-5">
            <img src={LOGO_URL} alt="Logo Guga Guincho" className="h-14 w-14 object-contain" />
            <div>
              <div className="font-display font-black text-2xl text-[#fddc04] tracking-tight">
                GUGA GUINCHO
              </div>
              <div className="text-[10px] uppercase tracking-[0.3em] text-zinc-500">
                Auto Socorro 24h • Campo Limpo • Zona Sul
              </div>
            </div>
          </div>
          <p className="text-zinc-400 max-w-md leading-relaxed">
            Guincho 24 horas no <strong className="text-white">Campo Limpo</strong> e em toda
            a <strong className="text-white">Zona Sul de São Paulo</strong>. Reboque rápido
            para carros, motos e utilitários, com equipe especializada e atendimento imediato
            via WhatsApp.
          </p>
          <div className="flex flex-col gap-2 mt-6">
            <a
              href={WHATSAPP_URL}
              target="_blank"
              rel="noreferrer"
              className="inline-flex items-center gap-2 text-zinc-300 hover:text-[#fddc04] font-medium"
              data-testid="footer-whatsapp-link"
            >
              <MessageCircle className="w-4 h-4 text-[#fddc04]" /> WhatsApp: {PHONE_DISPLAY}
            </a>
            <a
              href={TEL_URL}
              className="inline-flex items-center gap-2 text-zinc-300 hover:text-[#fddc04] font-medium"
              data-testid="footer-phone-link"
            >
              <Phone className="w-4 h-4 text-[#fddc04]" /> Telefone: {PHONE_DISPLAY}
            </a>
            <div className="inline-flex items-start gap-2 text-zinc-400 mt-2">
              <MapPin className="w-4 h-4 text-[#fddc04] mt-1 shrink-0" />
              <span>Rua Clemente Rocha, 560 — São Paulo / SP</span>
            </div>
          </div>
        </div>

        <div>
          <div className="font-display uppercase font-bold text-sm tracking-widest text-white mb-4">
            Links rápidos
          </div>
          <ul className="space-y-3">
            {[
              ["#sobre", "Sobre"],
              ["#servicos", "Serviços"],
              ["#diferenciais", "Diferenciais"],
              ["#trabalhos", "Trabalhos"],
              ["#areas", "Áreas atendidas"],
              ["#depoimentos", "Depoimentos"],
            ].map(([href, label]) => (
              <li key={href}>
                <a
                  href={href}
                  className="text-zinc-400 hover:text-[#fddc04] transition-colors"
                  data-testid={`footer-link-${label.toLowerCase().replace(/\s+/g, "-")}`}
                >
                  {label}
                </a>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <div className="font-display uppercase font-bold text-sm tracking-widest text-[#fc3202] mb-4">
            SEO Local
          </div>
          <p className="text-sm text-zinc-500 leading-relaxed">
            Guincho Campo Limpo, guincho Zona Sul SP, auto socorro Capão Redondo, reboque
            Vila Andrade, guincho Morumbi, guincho Santo Amaro, guincho Jabaquara, guincho
            Vila Mariana, guincho Moema, guincho Brooklin, guincho Ipiranga, plataforma
            para carros importados, troca de pneu, carga de bateria, chaveiro automotivo,
            atendimento 24 horas.
          </p>
        </div>
      </div>

      <div className="border-t border-zinc-900 pt-6 flex flex-col sm:flex-row justify-between items-center gap-4">
        <p className="text-xs text-zinc-600 uppercase tracking-widest">
          © {new Date().getFullYear()} Guga Guincho — Todos os direitos reservados.
        </p>
        <div className="flex items-center gap-2 text-xs text-zinc-600 uppercase tracking-widest">
          <CheckCircle2 className="w-4 h-4 text-[#fddc04]" />
          Atendendo 24h no Campo Limpo e Zona Sul de SP
        </div>
      </div>
    </div>
  </footer>
);

const FloatingWhatsApp = () => (
  <a
    href={WHATSAPP_URL}
    target="_blank"
    rel="noreferrer"
    aria-label="Chamar no WhatsApp"
    data-testid="whatsapp-floating-btn"
    className="fixed bottom-6 right-6 z-50 inline-flex items-center justify-center w-16 h-16 rounded-full bg-[#25D366] hover:bg-[#1faa55] text-white animate-pulse-glow"
  >
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      fill="currentColor"
      className="w-8 h-8"
    >
      <path d="M19.11 17.21c-.27-.13-1.6-.79-1.85-.88-.25-.09-.43-.13-.61.13-.18.27-.7.88-.86 1.06-.16.18-.32.2-.59.07-.27-.13-1.13-.42-2.16-1.34-.8-.71-1.34-1.59-1.5-1.86-.16-.27-.02-.42.12-.55.12-.12.27-.32.41-.48.14-.16.18-.27.27-.45.09-.18.05-.34-.02-.48-.07-.13-.61-1.47-.84-2.02-.22-.53-.45-.46-.61-.47-.16 0-.34-.02-.52-.02-.18 0-.48.07-.73.34-.25.27-.96.94-.96 2.29 0 1.35.99 2.66 1.13 2.84.13.18 1.94 2.97 4.7 4.16.66.28 1.17.45 1.57.58.66.21 1.26.18 1.74.11.53-.08 1.6-.65 1.83-1.27.23-.62.23-1.16.16-1.27-.07-.11-.25-.18-.52-.31zM16 4C9.93 4 5 8.93 5 15c0 1.94.51 3.83 1.48 5.5L4.91 26l5.66-1.49A11 11 0 0 0 16 26c6.07 0 11-4.93 11-11S22.07 4 16 4zm0 20c-1.71 0-3.38-.45-4.85-1.31l-.35-.21-3.36.88.9-3.27-.23-.34A8.96 8.96 0 0 1 7 15c0-4.96 4.04-9 9-9s9 4.04 9 9-4.04 9-9 9z" />
    </svg>
    <span className="absolute right-full mr-3 hidden md:inline-flex items-center gap-2 bg-black border border-zinc-800 text-white text-xs uppercase tracking-widest font-display font-bold px-3 py-2 whitespace-nowrap">
      Chamar agora <ChevronRight className="w-3 h-3" />
    </span>
  </a>
);

/* ---------- Page ---------- */

const Home = () => {
  useEffect(() => {
    document.title = "Guincho 24 Horas no Campo Limpo e Zona Sul | Guga Guincho";
  }, []);
  return (
    <div className="bg-black text-white min-h-screen" data-testid="home-page">
      <TopBanner />
      <Header />
      <main>
        <Hero />
        <About />
        <Services />
        <Differentials />
        <Gallery />
        <Areas />
        <Testimonials />
        <FinalCta />
      </main>
      <Footer />
      <FloatingWhatsApp />
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
